import { Button, Input, Modal } from "antd";
import React, { useState } from "react";
import "./style.css";
import TextArea from "antd/lib/input/TextArea";
import creditCardIcon from "../../Assets/images/credit_card.svg";
import netBankingIcon from "../../Assets/images/net-banking.svg";
import upiPaymentIcon from "../../Assets/images/upi-payment.svg";
import PaymentDetails from "./PaymentDetails";

export default function ChoosePlan({ isModalOpen, setIsModalOpen }) {
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const plans = [
    {
      id: 1,
      title: "Yearly",
      description: "Pay for a full year",
      price: "₹000.00",
    },
    {
      id: 2,
      title: "Monthly",
      description: "Pay monthly and cancel at any time.",
      price: "₹000.00",
    },
  ];
  const paymentMethods = [
    { id: 1, label: "Credit/Debit Card", icon: creditCardIcon },
    { id: 2, label: "Net Banking", icon: netBankingIcon },
    { id: 3, label: "UPI Payment", icon: upiPaymentIcon },
  ];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setShowPaymentDetails(true);
    // setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        closable={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Subscribe"
        className="hims-choose-plan-card"
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ maxWidth: "500px" }}>
            <div style={{ fontSize: "32px", fontWeight: "600" }}>
              Subscribe <span style={{ color: "#00A82E" }}>HIMS</span>
            </div>
            <div className="hims-input-container">
              <div className="hims-input">
                <label style={{ fontWeight: "500" }}>Billed To</label>
                <Input
                  className="hims-input-field"
                  type="text"
                  placeholder="Name"
                />
              </div>
              <div className="hims-input">
                <label style={{ fontWeight: "500" }}>Mobile No.</label>
                <Input
                  className="hims-input-field"
                  type="text"
                  placeholder="+91 0000000000"
                />
              </div>
            </div>
            <div
              style={{ width: "50%", marginTop: "16px" }}
              className="hims-input-container"
            >
              <div className="hims-input">
                <label style={{ fontWeight: "500" }}>Email</label>
                <Input
                  className="hims-input-field"
                  type="text"
                  placeholder="example@email.com"
                />
              </div>
            </div>
            <div style={{ marginTop: "16px" }} className="hims-input-container">
              <div style={{ width: "100%" }} className="hims-input">
                <label style={{ fontWeight: "500" }}>Address</label>
                <TextArea
                  className="hims-input-field"
                  type="text"
                  placeholder="Write"
                />
              </div>
            </div>
            <div className="payment-method-container">
              <div style={{ fontSize: "12px", fontWeight: "500" }}>
                Select Payment Method
              </div>
              <div style={{ display: "flex", gap: "24px" }}>
                {paymentMethods.map((method) => (
                  <PaymentMethodCard
                    key={method.id}
                    isActive={selectedMethod === method.id}
                    onClick={() => setSelectedMethod(method.id)}
                    label={method.label}
                    icon={method.icon}
                  />
                ))}
              </div>
            </div>
          </div>
          <div>
            <div
              style={{
                fontSize: "28px",
                fontWeight: "600",
                textAlign: "center",
                marginBottom: "32px",
              }}
            >
              Choose a Plan
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              {plans.map((plan) => (
                <PlanCard
                  key={plan.id}
                  isActive={selectedPlan === plan.id}
                  onClick={() => setSelectedPlan(plan.id)}
                  title={plan.title}
                  description={plan.description}
                  price={plan.price}
                />
              ))}
            </div>
          </div>
        </div>
      </Modal>
      <PaymentDetails
        isModalOpen={showPaymentDetails}
        setIsModalOpen={setShowPaymentDetails}
        setShowChoosePlan={setIsModalOpen}
      />
    </>
  );
}

function PaymentMethodCard({ isActive, onClick, label, icon }) {
  return (
    <div
      className={`payment-method-card ${
        isActive ? "payment-method-card-active" : ""
      }`}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <img src={icon} alt="" width={28} height={22} />
      <div style={{ marginTop: "10px", fontSize: "12px" }}>{label}</div>
    </div>
  );
}

function PlanCard({ isActive, onClick, title, description, price }) {
  return (
    <div
      onClick={onClick}
      style={{
        border: isActive
          ? "2px solid rgba(0, 168, 46, 1)"
          : "2px solid rgba(230, 230, 230, 1)",
        borderRadius: "8px",
        display: "flex",
        padding: "16px 12px",
        gap: "10px",
        justifyContent: "space-between",
        boxShadow: isActive ? "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" : "none",
        cursor: "pointer",
      }}
    >
      <div style={{ display: "flex", gap: "8px" }}>
        <div
          style={{
            height: "18px",
            width: "18px",
            borderRadius: "9999px",
            border: isActive
              ? "2px solid rgba(0, 168, 46, 1)"
              : "2px solid rgba(160, 160, 160, 1)",
            marginTop: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              borderRadius: "9999px",
              backgroundColor: isActive ? "rgba(0, 168, 46, 1)" : "white",
            }}
          ></div>
        </div>
        <div>
          <div style={{ fontSize: "18px", fontWeight: "600" }}>{title}</div>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            {description}
          </div>
        </div>
      </div>
      <div style={{ fontSize: "19px", fontWeight: "500" }}>{price}</div>
    </div>
  );
}
